"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
var _ref = {},
    toString = _ref.toString;

function isObject(obj) {
  return toString.call(obj) === '[object Object]';
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pc09iamVjdC5qcyJdLCJuYW1lcyI6WyJ0b1N0cmluZyIsImlzT2JqZWN0Iiwib2JqIiwiY2FsbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsV0FBcUIsRUFBckI7QUFBQSxJQUFRQSxRQUFSLFFBQVFBLFFBQVI7O0FBRWUsU0FBU0MsUUFBVCxDQUFrQkMsR0FBbEIsRUFBdUI7QUFDcEMsU0FBT0YsUUFBUSxDQUFDRyxJQUFULENBQWNELEdBQWQsTUFBdUIsaUJBQTlCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHsgdG9TdHJpbmcgfSA9IHt9O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBpc09iamVjdChvYmopIHtcbiAgcmV0dXJuIHRvU3RyaW5nLmNhbGwob2JqKSA9PT0gJ1tvYmplY3QgT2JqZWN0XSc7XG59XG4iXX0=